import {Space, Steps} from "antd";
import {useCreateStoreServiceContext} from "../../context/create-service";
import {CreateStoreServiceSteps} from "../../reducers/create-service/types";

export function CreateServiceFormSteps() {
  const {state} = useCreateStoreServiceContext();
  const mapStepToNumber: Record<CreateStoreServiceSteps, number> = {
    basicForm: 0,
    coverImagesUpload: 1,
    automations: 2,
    checkoutForm: 3,
  };

  return (
    <div>
      <Steps
        current={mapStepToNumber[state.currentCreateStoreServiceStep]}
        size="small"
        direction="vertical"
      >
        <Steps.Step title="Service information" />
        <Steps.Step
          title="Cover image upload"
          disabled={state.currentCreateStoreServiceStep === "basicForm"}
        />
        <Steps.Step
          title="Automations"
          disabled={
            state.currentCreateStoreServiceStep === "basicForm" ||
            state.currentCreateStoreServiceStep === "coverImagesUpload"
          }
        />
        <Steps.Step
          title="Checkout form"
          disabled={
            state.currentCreateStoreServiceStep === "basicForm" ||
            state.currentCreateStoreServiceStep === "coverImagesUpload" ||
            state.currentCreateStoreServiceStep === "automations"
          }
        />
      </Steps>
    </div>
  );
}

export function CreateServiceFormStepsMobile() {
  const {state} = useCreateStoreServiceContext();
  const mapStepToNumber: Record<CreateStoreServiceSteps, number> = {
    basicForm: 0,
    coverImagesUpload: 1,
    automations: 2,
    checkoutForm: 3,
  };
  const mapStepToTitle: Record<CreateStoreServiceSteps, string> = {
    basicForm: "Service information",
    checkoutForm: "Checkout form",
    coverImagesUpload: "Cover image upload",
    automations: "Automations",
  };
  return (
    <Space size={16} align="center">
      <div
        style={{
          width: "2.4rem",
          height: "2.4rem",
          borderRadius: "3.2rem",
          backgroundColor: "#222222",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {mapStepToNumber[state.currentCreateStoreServiceStep] + 1}
      </div>

      <p>{mapStepToTitle[state.currentCreateStoreServiceStep]}</p>
    </Space>
  );
}
